module.exports = __webpack_public_path__ + "img/Metastasis-CRC_CRLM.b44fb65e.png";